export const CONTESTATION_NATURE = {
  INCREASE: 'Augmentation',
  DISCOUNT: 'Réduction',
};
export const CONTESTATION_AGAINST_TYPE = {
  VICTIMS: {
    ITEM: 'victims',
    CONTESTATION: 'JudgementOnMeritsContestationVictim',
  },
  VEHICLES: {
    ITEM: 'vehicules',
    CONTESTATION: 'JudgementOnMeritsContestationVehicle',
  },
};
export const WITHDRAWAL_CONTESTATION_TYPE = 'Rétractation';
